__turbopack_context__.v({
  "disabled": "index-module__gIyzaG__disabled",
  "finished": "index-module__gIyzaG__finished",
  "finishedContainer": "index-module__gIyzaG__finishedContainer",
  "footer": "index-module__gIyzaG__footer",
  "footerRight": "index-module__gIyzaG__footerRight",
  "gradientBg": "index-module__gIyzaG__gradientBg",
  "newChatButtonContainer": "index-module__gIyzaG__newChatButtonContainer",
  "shimmer": "index-module__gIyzaG__shimmer",
  "smallUploadButton": "index-module__gIyzaG__smallUploadButton",
  "success": "index-module__gIyzaG__success",
  "textarea": "index-module__gIyzaG__textarea",
  "toast": "index-module__gIyzaG__toast",
  "toastIcon": "index-module__gIyzaG__toastIcon",
  "toastText": "index-module__gIyzaG__toastText",
  "waitingText": "index-module__gIyzaG__waitingText",
  "workingText": "index-module__gIyzaG__workingText",
  "wrapper": "index-module__gIyzaG__wrapper",
});
